import { getMobileBookingProgress } from '@components/BookingFlow/Common/bookingFlowProgress';
import { BookingStepUnavailablePage } from '@components/BookingFlow/Common/BookingStepUnavailablePage';
import { IncomingTireSeasonChoice } from '@components/BookingFlow/Common/IncomingTireSeasonChoice';
import { BookingScreen } from '@components/BookingFlow/Mobile/BookingScreen';
import { t } from '@lingui/core/macro';
import { compareLicensePlates, customerRoutes } from 'noddi-util';
import {
  useBookingActions,
  useBookingCars,
  useIncomingTireSeasonItems,
  useIsIncomingTireSeasonStepValid,
  useIsTireHotelPickupRequired
} from 'noddi-web';
import { useNavigate } from 'react-router-dom';

/** Which wheel set goes into storage, per car signed up for the tire hotel. Never preselected. */
export const TireHotelSeason = () => {
  const navigate = useNavigate();
  const bookingCars = useBookingCars();
  const incomingTireSeasonItems = useIncomingTireSeasonItems();
  const isStepValid = useIsIncomingTireSeasonStepValid();
  const isTireHotelPickupRequired = useIsTireHotelPickupRequired();
  const { setIncomingTireSeason } = useBookingActions();

  const carsToAsk = incomingTireSeasonItems.flatMap((item) => {
    const car = bookingCars.find((bookingCar) => compareLicensePlates(bookingCar.licensePlate, item.licensePlate));
    return car ? [{ item, car }] : [];
  });

  if (carsToAsk.length === 0) {
    return <BookingStepUnavailablePage missing='services' />;
  }

  return (
    <BookingScreen
      progress={getMobileBookingProgress('services')}
      onNextClicked={() => {
        navigate(
          isTireHotelPickupRequired
            ? customerRoutes.newBookingTireHotel.getPath()
            : customerRoutes.newBookingTimeWindow.getPath()
        );
      }}
      disableNextButton={!isStepValid}
      validationVariant='tireHotelSeasonRequired'
      title={t`Which tires should we store?`}
      description={t`We take the tires you choose to our tire hotel.`}
    >
      <IncomingTireSeasonChoice
        cars={carsToAsk.map(({ item, car }) => ({ car, selectedSeason: item.metaData?.incomingTireSeason }))}
        onSelect={(car, season) => setIncomingTireSeason({ licensePlate: car.licensePlate, season })}
      />
    </BookingScreen>
  );
};
